import {
	getApiRepublicStatistic,
	getApiLaborResources,
	getApiEmployment,
	getApiProfessionalTraining,
	getApiPublicWorks,
	getApiRecognitionUnemployed,
	getApiSubsidy,
	getApiJobs,
	getApiMigration,
	getApiStateInspection,
	getApiLaborSystem,
	getApiMainIndicator,
	getApiEmployedServiced,
	getApiJobSearchDirections,
	getApiYAMMT
} from '@/api/situation'


export default {
	namespaced: true,
	state: {
		republicStatistic: {},
		laborResources: {},
		employment: {},
		professionalTraining: {},
		publicWorks: {},
		recognitionUnemployed: {},
		subsidy: {},
		jobs: {},
		migration: {},
		stateInspection: {},
		laborSystem: {},
		indicatorMain: {},
		indicatorEmployedServiced: {},
		indicatorJobSearchDirections: {},
		yammt: {}
	},
	getters: {
		GET_REPUBLIC_STATISTIC: state => state.republicStatistic,
		GET_LABOR_RESOURCES: state => state.laborResources,
		GET_EMPLOYMENT: state => state.employment,
		GET_PROFESSIONAL_TRAINING: state => state.professionalTraining,
		GET_PUBLIC_WORKS: state => state.publicWorks,
		GET_RECOGNITION_UNEMPLOYED: state => state.recognitionUnemployed,
		GET_SUBSIDY: state => state.subsidy,
		GET_JOBS: state => state.jobs,
		GET_MIGRATION: state => state.migration,
		GET_STATE_INSPECTION: state => state.stateInspection,
		GET_LABOR_SYSTEM: state => state.laborSystem,
		GET_INDICATOR_MAIN: state => state.indicatorMain,
		GET_INDICATOR_EMPLOYED_SERVICED: state => state.indicatorEmployedServiced,
		GET_INDICATOR_JOB_SEARCH_DIRECTIONS: state => state.indicatorJobSearchDirections,
		GET_YAMMT: state => state.yammt
	},
	mutations: {
		SET_REPUBLIC_STATISTIC: (state, data) => {
			state.republicStatistic.data = data

			const total = {
				unemployed: 0,
				number_migrants: 0,
				number_employed: 0,
				training_count: 0,
				public_workers: 0,
				unemployed_count: 0,
				employed_count: 0,
				total_appeals: 0,
				all_count: 0,
				total_employees: 0
			}

			Object.entries(data).forEach(item => {
				total.unemployed += item[1].unemployed ? item[1].unemployed : 0
				total.number_migrants += item[1].number_migrants ? item[1].number_migrants : 0
				total.number_employed += item[1].number_employed ? item[1].number_employed : 0
				total.training_count += item[1].training_count ? item[1].training_count : 0
				total.public_workers += item[1].public_workers ? item[1].public_workers : 0
				total.unemployed_count += item[1].unemployed_count ? item[1].unemployed_count : 0
				total.employed_count += item[1].employed_count ? item[1].employed_count : 0
				total.total_appeals += item[1].total_appeals ? item[1].total_appeals : 0
				total.all_count += item[1].all_count ? item[1].all_count : 0
				total.total_employees += item[1].total_employees ? item[1].total_employees : 0
			})

			state.republicStatistic.total = total
		},
		SET_LABOR_RESOURCES: (state, data) => {
			state.laborResources.data = data

			const total = {
				total_employees: 0,
				active_population: 0,
				employees: 0,
				average_populartion: 0,
				unemployed: 0,
				rate_unemployement: 0,
				unactive_population: 0
			}

			Object.entries(data).forEach(item => {
				total.total_employees += item[1].total_employees.value,
					total.active_population += item[1].active_population,
					total.employees += item[1].employees,
					total.average_populartion += item[1].average_populartion,
					total.unemployed += item[1].unemployed,
					total.rate_unemployement += item[1].rate_unemployement,
					total.unactive_population += item[1].unactive_population
			})
			state.laborResources.total = total
		},
		SET_EMPLOYMENT: (state, data) => {
			state.employment.data = data

			const total = {
				unemployed: 0,
				vacancies: 0,
				applicants: 0,
				number_employed: 0
			}

			Object.entries(data).forEach(item => {
				total.unemployed += item[1].unemployed.value ? item[1].unemployed.value : 0,
					total.vacancies += item[1].vacancies ? item[1].vacancies.value : 0,
					total.applicants += item[1].applicants.value ? item[1].applicants.value : 0,
					total.number_employed += item[1].number_employed ? item[1].number_employed : 0
			})

			state.employment.total = total
		},
		SET_PROFESSIONAL_TRAINING: (state, data) => {
			state.professionalTraining.data = data

			const total = {
				issued_count: 0,
				started_count: 0,
				ended_count: 0,
				not_ended_count: 0,
				employed_count: 0,
				ministry_system_count: 0,
				master_student_count: 0,
				without_ministry_count: 0,
				non_state_system_count: 0,
				self_employment_count: 0,
				yatt_count: 0,
				subsidied_count: 0,
				as_manual_worker: 0,
				microcredit_recipients: 0,
				all_count_edu: 0,
				ministry_system_edu: 0,
				not_ministry_system_edu: 0,
				non_state_educational_institution_edu: 0,
				master_disciple_edu: 0,
				all_count_capacity: 0,
				ministry_system_capacity: 0,
				not_ministry_system_capacity: 0,
				non_state_educational_institution_capacity: 0,
				master_disciple_capacity: 0,
				ministry_started_count: 0
			}

			Object.entries(data).forEach(item => {
				total.issued_count += item[1].issued_count ? item[1].issued_count : 0
				total.started_count += item[1].started_count ? item[1].started_count : 0
				total.ended_count += item[1].ended_count ? item[1].ended_count : 0
				total.not_ended_count += item[1].not_ended_count ? item[1].not_ended_count : 0
				total.employed_count += item[1].employed_count ? item[1].employed_count : 0
				total.ministry_system_count += item[1].ministry_system_count ? item[1].ministry_system_count : 0
				total.master_student_count += item[1].master_student_count ? item[1].master_student_count : 0
				total.without_ministry_count += item[1].without_ministry_count ? item[1].without_ministry_count : 0
				total.non_state_system_count += item[1].non_state_system_count ? item[1].non_state_system_count : 0
				total.yatt_count += item[1].yatt_count ? item[1].yatt_count : 0
				total.self_employment_count += item[1].self_employment_count ? item[1].self_employment_count : 0
				total.subsidied_count += item[1].subsidied_count ? item[1].subsidied_count : 0
				total.as_manual_worker += item[1].as_manual_worker ? item[1].as_manual_worker : 0
				total.microcredit_recipients += item[1].microcredit_recipients ? item[1].microcredit_recipients : 0
				total.all_count_edu += item[1].all_count_edu ? item[1].all_count_edu : 0
				total.ministry_system_edu += item[1].ministry_system_edu ? item[1].ministry_system_edu : 0
				total.not_ministry_system_edu += item[1].not_ministry_system_edu ? item[1].not_ministry_system_edu : 0
				total.non_state_educational_institution_edu += item[1].non_state_educational_institution_edu ? item[1].non_state_educational_institution_edu : 0
				total.master_disciple_edu += item[1].master_disciple_edu ? item[1].master_disciple_edu : 0
				total.all_count_capacity += item[1].all_count_capacity ? item[1].all_count_capacity : 0
				total.ministry_system_capacity += item[1].ministry_system_capacity ? item[1].ministry_system_capacity : 0
				total.not_ministry_system_capacity += item[1].not_ministry_system_capacity ? item[1].not_ministry_system_capacity : 0
				total.non_state_educational_institution_capacity += item[1].non_state_educational_institution_capacity ? item[1].non_state_educational_institution_capacity : 0
				total.master_disciple_capacity += item[1].master_disciple_capacity ? item[1].master_disciple_capacity : 0
				total.ministry_started_count += item[1].ministry_started_count ? item[1].ministry_started_count : 0
			})

			state.professionalTraining.total = total
		},
		SET_PUBLIC_WORKS: (state, data) => {
			state.publicWorks.data = data

			const total = {
				state_workers: 0,
				non_state_workers: 0,
				state_salary: 0,
				non_state_salary: 0,
				employed_count: 0,
				self_employment_count: 0,
				yatt_count: 0,
				subsidied_count: 0,
				state_employed_percent: 0,
				non_state_employed_percent: 0,
				microcredit_recipients: 0,
				as_manual_worker: 0,
				workers: 0,
				salary: 0
			}

			Object.entries(data).forEach(item => {
				total.state_workers += item[1].state_workers ? item[1].state_workers : 0
				total.non_state_workers += item[1].non_state_workers ? item[1].non_state_workers : 0
				total.state_salary += item[1].state_salary ? item[1].state_salary : 0
				total.non_state_salary += item[1].non_state_salary ? item[1].non_state_salary : 0
				total.employed_count += item[1].employed_count ? item[1].employed_count : 0
				total.self_employment_count += item[1].self_employment_count ? item[1].self_employment_count : 0
				total.yatt_count += item[1].yatt_count ? item[1].yatt_count : 0
				total.subsidied_count += item[1].subsidied_count ? item[1].subsidied_count : 0
				total.state_employed_percent += item[1].state_employed_percent ? item[1].state_employed_percent : 0
				total.non_state_employed_percent += item[1].non_state_employed_percent ? item[1].non_state_employed_percent : 0
				total.microcredit_recipients += item[1].microcredit_recipients ? item[1].microcredit_recipients : 0
				total.as_manual_worker += item[1].as_manual_worker ? item[1].as_manual_worker : 0
				total.workers += item[1].workers ? item[1].workers : 0
				total.salary += item[1].salary ? item[1].salary : 0
			})

			state.publicWorks.total = total
		},
		SET_RECOGNITION_UNEMPLOYED: (state, data) => {
			state.recognitionUnemployed.data = data

			const total = {
				unemployed_count: 0,
				unemployed_sum: 0,
				paused: 0,
				stopped: 0,
				employed: 0,
				first_unemployed: 0,
				inside_unemployed_12: 0,
				outside_unemployed_12: 0,
				employed_count: 0,
				self_employment_count: 0,
				yatt_count: 0,
				subsidied_count: 0,
				microcredit_recipients: 0,
				as_manual_worker: 0
			}

			data.forEach(item => {
				total.unemployed_count += item.unemployed_count ? item.unemployed_count : 0,
					total.unemployed_sum += Number(item.unemployed_sum) ? Number(item.unemployed_sum) : 0,
					total.paused += item.paused ? item.paused : 0,
					total.stopped += item.stopped ? item.stopped : 0,
					total.employed += item.employed ? item.employed : 0,
					total.first_unemployed += item.first_unemployed ? item.first_unemployed : 0,
					total.inside_unemployed_12 += item.inside_unemployed_12 ? item.inside_unemployed_12 : 0,
					total.outside_unemployed_12 += item.outside_unemployed_12 ? item.outside_unemployed_12 : 0,
					total.employed_count += item.employed_count ? item.employed_count : 0,
					total.self_employment_count += item.self_employment_count ? item.self_employment_count : 0,
					total.yatt_count += item.yatt_count ? item.yatt_count : 0,
					total.subsidied_count += item.subsidied_count ? item.subsidied_count : 0,
					total.microcredit_recipients += item.microcredit_recipients ? item.microcredit_recipients : 0,
					total.as_manual_worker += item.as_manual_worker ? item.as_manual_worker : 0
			})
			state.recognitionUnemployed.total = total
		},
		SET_SUBSIDY: (state, data) => {
			state.subsidy.data = data


			const total = {
				forest_count: 0,
				job_matching_count: 0,
				job_matching_sum: 0,
				mccs_sum: 0,
				mcsq_sum: 0,
				mcss_sum: 0,
				msms_sum: 0,
				mss_sum: 0,
				quote_count: 0,
				with_disability_count: 0,
				with_disability_sum: 0,
				yur_count: 0,
				employed_count: 0,
				self_employment_count: 0,
				subsidied_count: 0,
				yatt_count: 0,
				microcredit_recipients: 0,
				as_manual_worker: 0,
				household_count: 0,
				household_sum: 0,
				quote_sum: 0,
				quote_person_count: 0,
				with_disability_person_count: 0,
				job_matching_person_count: 0,
				mss_count: 0,
				mss_person_count: 0,
				fundH_count: 0,
				fundH_person_count: 0,
				fundH_sum: 0,
				publicH_count: 0,
				publicH_person_count: 0,
				publicH__sum: 0,
				forest_person_count: 0,
				forest_sum: 0,
			}

			data.forEach(item => {
				total.forest_count += item.forest_count ? Number(item.forest_count) : 0,
					total.job_matching_count += item.job_matching_count ? Number(item.job_matching_count) : 0,
					total.job_matching_sum += item.job_matching_sum ? Number(item.job_matching_sum) : 0,
					total.mccs_sum += item.mccs_sum ? Number(item.mccs_sum) : 0,
					total.mcsq_sum += item.mcsq_sum ? Number(item.mcsq_sum) : 0,
					total.mcss_sum += item.mcss_sum ? Number(item.mcss_sum) : 0,
					total.msms_sum += item.msms_sum ? Number(item.msms_sum) : 0,
					total.mss_sum += item.mss_sum ? Number(item.mss_sum) : 0,
					total.quote_count += item.quote_count ? Number(item.quote_count) : 0,
					total.with_disability_count += item.with_disability_count ? Number(item.with_disability_count) : 0,
					total.with_disability_sum += item.with_disability_sum ? Number(item.with_disability_sum) : 0,
					total.yur_count += item.yur_count ? Number(item.yur_count) : 0,
					total.employed_count += item.employed_count ? Number(item.employed_count) : 0,
					total.self_employment_count += item.self_employment_count ? Number(item.self_employment_count) : 0,
					total.subsidied_count += item.subsidied_count ? Number(item.subsidied_count) : 0,
					total.yatt_count += item.yatt_count ? Number(item.yatt_count) : 0,
					total.microcredit_recipients += item.microcredit_recipients ? Number(item.microcredit_recipients) : 0,
					total.as_manual_worker += item.as_manual_worker ? Number(item.as_manual_worker) : 0,
					total.household_count += item.household_count ? Number(item.household_count) : 0,
					total.household_sum += item.household_sum ? Number(item.household_sum) : 0,
					total.quote_sum += item.quote_sum ? Number(item.quote_sum) : 0,
					total.quote_person_count += item.quote_person_count ? Number(item.quote_person_count) : 0,
					total.with_disability_person_count += item.with_disability_person_count ? Number(item.with_disability_person_count) : 0,
					total.job_matching_person_count += item.job_matching_person_count ? Number(item.job_matching_person_count) : 0,
					total.mss_count += item.mss_count ? Number(item.mss_count) : 0,
					total.mss_person_count += item.mss_person_count ? Number(item.mss_person_count) : 0,
					total.fundH_count += item.fundH_count ? Number(item.fundH_count) : 0,
					total.fundH_person_count += item.fundH_person_count ? Number(item.fundH_person_count) : 0,
					total.fundH_sum += item.fundH_sum ? Number(item.fundH_sum) : 0,
					total.publicH_count += item.publicH_count ? Number(item.publicH_count) : 0,
					total.publicH_person_count += item.publicH_person_count ? Number(item.publicH_person_count) : 0,
					total.forest_person_count += item.forest_person_count ? Number(item.forest_person_count) : 0,
					total.publicH__sum += item.publicH__sum ? Number(item.publicH__sum) : 0,
					total.forest_sum += item.forest_sum ? Number(item.forest_sum) : 0
			})

			state.subsidy.total = total
		},
		SET_JOBS: (state, data) => {
			state.jobs.data = data

			const total = {
				total_employees: 0,
				employed_in_permanent_jobs: 0,
				seasonal_temporary_jobs: 0,
				legal_works: 0
			}

			Object.entries(data).forEach(item => {
				total.total_employees += item[1].total_employees ? item[1].total_employees : 0,
					total.employed_in_permanent_jobs += item[1].employed_in_permanent_jobs ? item[1].employed_in_permanent_jobs : 0,
					total.seasonal_temporary_jobs += item[1].seasonal_temporary_jobs ? item[1].seasonal_temporary_jobs : 0,
					total.legal_works += item[1].legal_works ? item[1].legal_works : 0
			})

			state.jobs.total = total
		},
		SET_MIGRATION: (state, data) => {
			state.migration.data = data

			const total = {
				number_vacancies_foreign: 0,
				work_abroad_intention: 0,
				workers_abroad_by_tmma: 0,
				self_employed_abroad: 0,
				number_of_vacancies: 0,
				returnees_abroad: 0,
				vacancy: 0,
				desire_work: 0,
				employed_independent: 0,
				employed_tmma: 0,
				vacancies: 0
			}

			Object.entries(data).forEach(item => {
				total.number_vacancies_foreign += item[1].number_vacancies_foreign ? item[1].number_vacancies_foreign : 0
				total.work_abroad_intention += item[1].work_abroad_intention ? item[1].work_abroad_intention : 0
				total.workers_abroad_by_tmma += item[1].workers_abroad_by_tmma ? item[1].workers_abroad_by_tmma : 0
				total.self_employed_abroad += item[1].self_employed_abroad ? item[1].self_employed_abroad : 0
				total.number_of_vacancies += item[1].number_of_vacancies ? item[1].number_of_vacancies : 0
				total.returnees_abroad += item[1].returnees_abroad ? item[1].returnees_abroad : 0
				total.vacancy += item[1].vacancy ? item[1].vacancy : 0
				total.desire_work += item[1].desire_work ? item[1].desire_work : 0
				total.employed_independent += item[1].employed_independent ? item[1].employed_independent : 0
				total.employed_tmma += item[1].employed_tmma ? item[1].employed_tmma : 0
				total.vacancies += item[1].vacancies ? item[1].vacancies : 0
			})

			state.migration.total = total
		},
		SET_STATE_INSPECTION: (state, data) => {
			state.stateInspection.data = data

			const total = {
				violation_law_employment: 0,
				denial_employment: 0,
				illegal_dismissal: 0,
				informal_use: 0,
				failure_pay_payments: 0,
				regarding_mandatory_wages: 0,
				forced_labor: 0,
				accidents: 0,
				regarding_labor_protection: 0,
				other_issues: 0,
				satisfied: 0,
				explanation_given: 0,
				number_jobs_created: 0,
				number_uncreated_jobs: 0,
				number_fines_applied: 0,
				amount_fines_applied: 0,
				number_campaigns_tv: 0,
				number_campaigns_internet: 0,
				number_campaigns_newspaper: 0,
				number_campaigns_seminars: 0,
				number_campaigns_others: 0,
				number_violations_inspections: 0,
				number_instructions_inspections: 0,
				number_submissions_inspections: 0,
				number_fines_49: 0,
				amount_fines_49: 0,
				number_fines_50: 0,
				amount_fines_50: 0,
				number_fines_51: 0,
				amount_fines_51: 0,
				number_fines_257: 0,
				amount_fines_257: 0,
				arrears_wages_enterprises_number: 0,
				arrears_wages_enterprises_amount: 0,
				arrears_wages_employees_count: 0,
				applications_fees_count: 0,
				applications_fees_amount: 0,
				rest_hours_count: 0,
				monitored_enterprises_count: 0,
				work_on_holidays_count: 0,
				officials_fined_count: 0,
				officials_fined_amount: 0,
				accidents_count: 0,
				accident_investigations_count: 0,
				accidents_group_count: 0,
				accidents_death_count: 0,
				accident_bad_count: 0,
				accident_enterprises_count: 0,
				violation_detected: 0,
				number_inspections_studies: 0,
				number_enterprises_more_20_state: 0,
				ignored_applications: 0,
				sent_other_agencies: 0
			}

			Object.entries(data).forEach(item => {
				total.violation_law_employment += item[1].violation_law_employment ? item[1].violation_law_employment : 0,
					total.denial_employment += item[1].denial_employment ? item[1].denial_employment : 0,
					total.illegal_dismissal += item[1].illegal_dismissal ? item[1].illegal_dismissal : 0,
					total.informal_use += item[1].informal_use ? item[1].informal_use : 0,
					total.failure_pay_payments += item[1].failure_pay_payments ? item[1].failure_pay_payments : 0,
					total.regarding_mandatory_wages += item[1].regarding_mandatory_wages ? item[1].regarding_mandatory_wages : 0,
					total.forced_labor += item[1].forced_labor ? item[1].forced_labor : 0,
					total.accidents += item[1].accidents ? item[1].accidents : 0,
					total.regarding_labor_protection += item[1].regarding_labor_protection ? item[1].regarding_labor_protection : 0,
					total.other_issues += item[1].other_issues ? item[1].other_issues : 0,
					total.satisfied += item[1].satisfied ? item[1].satisfied : 0,
					total.explanation_given += item[1].explanation_given ? item[1].explanation_given : 0,
					total.number_jobs_created += item[1].number_jobs_created ? item[1].number_jobs_created : 0,
					total.number_uncreated_jobs += item[1].number_uncreated_jobs ? item[1].number_uncreated_jobs : 0,
					total.number_fines_applied += item[1].number_fines_applied ? item[1].number_fines_applied : 0,
					total.amount_fines_applied += item[1].amount_fines_applied ? item[1].amount_fines_applied : 0,
					total.number_campaigns_tv += item[1].number_campaigns_tv ? item[1].number_campaigns_tv : 0,
					total.number_campaigns_internet += item[1].number_campaigns_internet ? item[1].number_campaigns_internet : 0,
					total.number_campaigns_newspaper += item[1].number_campaigns_newspaper ? item[1].number_campaigns_newspaper : 0,
					total.number_campaigns_seminars += item[1].number_campaigns_seminars ? item[1].number_campaigns_seminars : 0,
					total.number_campaigns_others += item[1].number_campaigns_others ? item[1].number_campaigns_others : 0,
					total.number_violations_inspections += item[1].number_violations_inspections ? item[1].number_violations_inspections : 0,
					total.number_instructions_inspections += item[1].number_instructions_inspections ? item[1].number_instructions_inspections : 0,
					total.number_submissions_inspections += item[1].number_submissions_inspections ? item[1].number_submissions_inspections : 0,
					total.number_fines_49 += item[1].number_fines_49 ? item[1].number_fines_49 : 0,
					total.amount_fines_49 += item[1].amount_fines_49 ? item[1].amount_fines_49 : 0,
					total.number_fines_50 += item[1].number_fines_50 ? item[1].number_fines_50 : 0,
					total.amount_fines_50 += item[1].amount_fines_50 ? item[1].amount_fines_50 : 0,
					total.number_fines_51 += item[1].number_fines_51 ? item[1].number_fines_51 : 0,
					total.amount_fines_51 += item[1].amount_fines_51 ? item[1].amount_fines_51 : 0,
					total.number_fines_257 += item[1].number_fines_257 ? item[1].number_fines_257 : 0,
					total.amount_fines_257 += item[1].amount_fines_257 ? item[1].amount_fines_257 : 0,
					total.arrears_wages_enterprises_number += item[1].arrears_wages_enterprises_number ? item[1].arrears_wages_enterprises_number : 0,
					total.arrears_wages_enterprises_amount += item[1].arrears_wages_enterprises_amount ? item[1].arrears_wages_enterprises_amount : 0,
					total.arrears_wages_employees_count += item[1].arrears_wages_employees_count ? item[1].arrears_wages_employees_count : 0,
					total.applications_fees_count += item[1].applications_fees_count ? item[1].applications_fees_count : 0,
					total.applications_fees_amount += item[1].applications_fees_amount ? item[1].applications_fees_amount : 0,
					total.rest_hours_count += item[1].rest_hours_count ? item[1].rest_hours_count : 0,
					total.monitored_enterprises_count += item[1].monitored_enterprises_count ? item[1].monitored_enterprises_count : 0,
					total.work_on_holidays_count += item[1].work_on_holidays_count ? item[1].work_on_holidays_count : 0,
					total.officials_fined_count += item[1].officials_fined_count ? item[1].officials_fined_count : 0,
					total.officials_fined_amount += item[1].officials_fined_amount ? item[1].officials_fined_amount : 0,
					total.accidents_count += item[1].accidents_count ? item[1].accidents_count : 0,
					total.accident_investigations_count += item[1].accident_investigations_count ? item[1].accident_investigations_count : 0,
					total.accidents_group_count += item[1].accidents_group_count ? item[1].accidents_group_count : 0,
					total.accidents_death_count += item[1].accidents_death_count ? item[1].accidents_death_count : 0,
					total.accident_bad_count += item[1].accident_bad_count ? item[1].accident_bad_count : 0,
					total.accident_enterprises_count += item[1].accident_enterprises_count ? item[1].accident_enterprises_count : 0,
					total.violation_detected += item[1].violation_detected ? item[1].violation_detected : 0,
					total.number_inspections_studies += item[1].number_inspections_studies ? item[1].number_inspections_studies : 0,
					total.number_enterprises_more_20_state += item[1].number_enterprises_more_20_state ? item[1].number_enterprises_more_20_state : 0,
					total.ignored_applications += item[1].ignored_applications ? item[1].ignored_applications : 0,
					total.sent_other_agencies += item[1].sent_other_agencies ? item[1].sent_other_agencies : 0
			})

			state.stateInspection.total = total
		},
		SET_LABOR_SYSTEM: (state, data) => {
			state.laborSystem.data = data

			const total = {
				violation_law_employment: 0,
			}

			Object.entries(data).forEach(item => {
				total.violation_law_employment += item[1].violation_law_employment ? item[1].violation_law_employment : 0
			})

			state.laborSystem.total = total
		},
		SET_INDICATOR_MAIN: (state, data) => {
			state.indicatorMain.data = data

			const total = {
				fiveDays: 0,
				unemployment2Week: 0,
				trainingNotClosed: 0,
				notOutedEmployeds: 0,
				unconfirmedMonitoring: 0,
				notServiced: 0
			}

			Object.entries(data).forEach(item => {
				total.fiveDays += item[1].fiveDays ? item[1].fiveDays : 0,
					total.unemployment2Week += item[1].unemployment2Week ? item[1].unemployment2Week : 0,
					total.trainingNotClosed += item[1].trainingNotClosed ? item[1].trainingNotClosed : 0,
					total.notOutedEmployeds += item[1].notOutedEmployeds ? item[1].notOutedEmployeds : 0,
					total.unconfirmedMonitoring += item[1].unconfirmedMonitoring ? item[1].unconfirmedMonitoring : 0,
					total.notServiced += item[1].notServiced ? item[1].notServiced : 0
			})

			state.indicatorMain.total = total
		},
		SET_INDICATOR_EMPLOYED_SERVICED: (state, data) => {
			state.indicatorEmployedServiced.data = data

			const total = {
				services_count: 0,
				training_count: 0,
				pworkers_count: 0,
				unemployment_count: 0
			}

			Object.entries(data).forEach(item => {
				total.services_count += item[1].services_count ? item[1].services_count : 0,
					total.training_count += item[1].training_count ? item[1].training_count : 0,
					total.pworkers_count += item[1].pworkers_count ? item[1].pworkers_count : 0,
					total.unemployment_count += item[1].unemployment_count ? item[1].unemployment_count : 0
			})

			state.indicatorEmployedServiced.total = total
		},
		SET_INDICATOR_JOB_SEARCH_DIRECTIONS: (state, data) => {
			state.indicatorJobSearchDirections.data = data

			const total = {
				all_count: 0,
				given_count: 0,
				employed_count: 0,
				failure_count: 0,
				not_given_count: 0,
				before_employed_count: 0,
				not_resulted_5_days_count: 0
			}

			Object.entries(data).forEach(item => {
				total.all_count += item[1].all_count ? item[1].all_count : 0,
					total.given_count += item[1].given_count ? item[1].given_count : 0,
					total.employed_count += item[1].employed_count ? item[1].employed_count : 0,
					total.failure_count += item[1].failure_count ? item[1].failure_count : 0,
					total.not_given_count += item[1].not_given_count ? item[1].not_given_count : 0,
					total.before_employed_count += item[1].before_employed_count ? item[1].before_employed_count : 0,
					total.not_resulted_5_days_count += item[1].not_resulted_5_days_count ? item[1].not_resulted_5_days_count : 0
			})

			state.indicatorJobSearchDirections.total = total
		},
		SET_YAMMT: (state, data) => {
			state.yammt.data = data

			const total = {
				age_18_30: 0,
				dismissed_sum: 0,
				ggs_18_30: 0,
				invalids_ggs: 0,
				invalids_not_ggs: 0,
				men: 0,
				new_contracts_sum: 0,
				pensioners_ggs: 0,
				pensioners_not_ggs: 0,
				soato_code: 0,
				students_ggs: 0,
				students_not_ggs: 0,
				women_ggs: 0,
				women_not_ggs_count: 0
			}

			Object.entries(data).forEach(item => {
				total.age_18_30 += item[1].age_18_30 ? item[1].age_18_30 : 0,
					total.dismissed_sum += item[1].dismissed_sum ? item[1].dismissed_sum : 0,
					total.ggs_18_30 += item[1].ggs_18_30 ? item[1].ggs_18_30 : 0,
					total.invalids_ggs += item[1].invalids_ggs ? item[1].invalids_ggs : 0,
					total.invalids_not_ggs += item[1].invalids_not_ggs ? item[1].invalids_not_ggs : 0,
					total.men += item[1].men ? item[1].men : 0,
					total.new_contracts_sum += item[1].new_contracts_sum ? item[1].new_contracts_sum : 0,
					total.pensioners_ggs += item[1].pensioners_ggs ? item[1].pensioners_ggs : 0,
					total.pensioners_not_ggs += item[1].pensioners_not_ggs ? item[1].pensioners_not_ggs : 0,
					total.soato_code += item[1].soato_code ? item[1].soato_code : 0,
					total.students_ggs += item[1].students_ggs ? item[1].students_ggs : 0,
					total.students_not_ggs += item[1].students_not_ggs ? item[1].students_not_ggs : 0,
					total.women_ggs += item[1].women_ggs ? item[1].women_ggs : 0,
					total.women_not_ggs_count += item[1].women_not_ggs_count ? item[1].women_not_ggs_count : 0
			})

			state.yammt.total = total
		}
	},
	actions: {
		getRepublicStatistic({ commit }, params) {
			return new Promise((resolve, reject) => {
				getApiRepublicStatistic(params).then(res => {
					commit('SET_REPUBLIC_STATISTIC', res.data)

					resolve(res)
				}).catch(error => reject(error))
			})
		},
		getlaborResources({ commit }, params) {
			return new Promise((resolve, reject) => {
				getApiLaborResources(params).then(res => {
					commit('SET_LABOR_RESOURCES', res.data)

					resolve(res)
				}).catch(error => reject(error))
			})
		},
		getEmployment({ commit }, params) {
			return new Promise((resolve, reject) => {
				getApiEmployment(params).then(res => {
					commit('SET_EMPLOYMENT', res.data)

					resolve(res)
				}).catch(error => reject(error))
			})
		},
		getProfessionalTraining({ commit }, params) {
			return new Promise((resolve, reject) => {
				getApiProfessionalTraining(params).then(res => {
					commit('SET_PROFESSIONAL_TRAINING', res.data)

					resolve(res)
				}).catch(error => reject(error))
			})
		},
		getRecognitionUnemployed({ commit }, params) {
			return new Promise((resolve, reject) => {
				getApiRecognitionUnemployed(params).then(res => {
					commit('SET_RECOGNITION_UNEMPLOYED', res.data)

					resolve(res)
				}).catch(error => reject(error))
			})
		},
		getPublicWorks({ commit }, params) {
			return new Promise((resolve, reject) => {
				getApiPublicWorks(params).then(res => {
					commit('SET_PUBLIC_WORKS', res.data)

					resolve(res)
				}).catch(error => reject(error))
			})
		},
		getSubsidy({ commit }, params) {
			return new Promise((resolve, reject) => {
				getApiSubsidy(params).then(res => {
					commit('SET_SUBSIDY', res.data)

					resolve(res)
				}).catch(error => reject(error))
			})
		},
		getJobs({ commit }, params) {
			return new Promise((resolve, reject) => {
				getApiJobs(params).then(res => {
					commit('SET_JOBS', res.data)

					resolve(res)
				}).catch(error => reject(error))
			})
		},
		getMigration({ commit }, params) {
			return new Promise((resolve, reject) => {
				getApiMigration(params).then(res => {
					commit('SET_MIGRATION', res.data)

					resolve(res)
				}).catch(error => reject(error))
			})
		},
		getStateInspection({ commit }, params) {
			return new Promise((resolve, reject) => {
				getApiStateInspection(params).then(res => {
					commit('SET_STATE_INSPECTION', res.data)

					resolve(res)
				}).catch(error => reject(error))
			})
		},
		getLaborSystem({ commit }, params) {
			return new Promise((resolve, reject) => {
				getApiLaborSystem(params).then(res => {
					commit('SET_LABOR_SYSTEM', res.data)

					resolve(res)
				}).catch(error => reject(error))
			})
		},
		getIndicatorMain({ commit }, params) {
			return new Promise((resolve, reject) => {
				getApiMainIndicator(params).then(res => {
					commit('SET_INDICATOR_MAIN', res.data)

					resolve(res)
				}).catch(error => reject(error))
			})
		},
		getIndicatorEmployedServiced({ commit }, params) {
			return new Promise((resolve, reject) => {
				getApiEmployedServiced(params).then(res => {
					commit('SET_INDICATOR_EMPLOYED_SERVICED', res.data)

					resolve(res)
				}).catch(error => reject(error))
			})
		},
		getIndicatorJobSearchDirections({ commit }, params) {
			return new Promise((resolve, reject) => {
				getApiJobSearchDirections(params).then(res => {
					commit('SET_INDICATOR_JOB_SEARCH_DIRECTIONS', res.data)

					resolve(res)
				}).catch(error => reject(error))
			})
		},
		getYAMMT({ commit }, params) {
			return new Promise((resolve, reject) => {
				getApiYAMMT(params).then(res => {
					commit('SET_YAMMT', res.data)

					resolve(res)
				}).catch(error => reject(error))
			})
		}
	}
}